import React, { useState } from "react";
import SignupRight from "./SignupRight";
import AddPersonalDetails from "./AddPersonalDetails";
import ApiCall from "../../../api/ApiCall";
import { signupEndpoints } from "../../../api/Endpoints";
import { useNavigate } from "react-router-dom";
import LoginLeft from "../Login/LoginLeft";
import { startApiCall } from "../../../global-functions/globalFunctions";
import AuthenticateFooter from "../../../components/Footers/AuthenticateFooter";
import OtpVerifyForRegistration from "./OtpVerifyForRegistration";

const Signup = () => {
  const navigate = useNavigate();
  const [firstStep, setfirstStep] = useState(true);
  const [secondStep, setsecondStep] = useState(false);
  const [thirdStep, setthirdStep] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [otpString, setOtpString] = useState("");
  const [otp, setotp] = useState(new Array(6).fill(""));
  const [errorMessage, seterrorMessage] = useState("");
  const [loader, setloader] = useState(false);
  const [loader2, setloader2] = useState(false);

  const resetStep = () => {
    setfirstStep(true);
    setsecondStep(false);
    setthirdStep(false);
  };
  const completeFirstStep = () => {
    setfirstStep(false);
    setsecondStep(true);
    setthirdStep(false);
  };
  const completeSecondStep = () => {
    setfirstStep(false);
    setsecondStep(false);
    setthirdStep(true);
  };

  const handleEmailVerify = async (e) => {
    e.preventDefault();
    startApiCall(seterrorMessage, setloader2);
    const res = await ApiCall("post", signupEndpoints.sendOtpForRegistration, {
      email,
    });
    if (res?.success) {
      setotp(new Array(6).fill(""));
      setOtpString("");
      setloader2(false);
      completeFirstStep();
    } else {
      setloader2(false);
      seterrorMessage(res.error);
    }
  };

  return (
    <>
      <div className="hk-wrapper hk-pg-auth" data-footer="simple">
        <div className="hk-pg-wrapper pb-7">
          <div className="hk-pg-body p-0">
            <div className="container-xxl">
              <div className="row">
                <LoginLeft />
                {firstStep && !secondStep && !thirdStep && (
                  <SignupRight
                    setEmail={setEmail}
                    email={email}
                    errorMessage={errorMessage}
                    loader={loader2}
                    handleEmailVerify={handleEmailVerify}
                  />
                )}
                {!firstStep && secondStep && !thirdStep && (
                  <OtpVerifyForRegistration
                    completeSecondStep={completeSecondStep}
                    email={email}
                    errorMessage={errorMessage}
                    seterrorMessage={seterrorMessage}
                    loader={loader}
                    setloader={setloader}
                    otp={otp}
                    setotp={setotp}
                    otpString={otpString}
                    setOtpString={setOtpString}
                    handleEmailVerify={handleEmailVerify}
                    loader2={loader2}
                    resetStep={resetStep}
                  />
                )}
                {!firstStep && !secondStep && thirdStep && (
                  <AddPersonalDetails
                    firstName={firstName}
                    setfirstName={setfirstName}
                    lastName={lastName}
                    setlastName={setlastName}
                    password={password}
                    setPassword={setPassword}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                    errorMessage={errorMessage}
                    loader={loader}
                    seterrorMessage={seterrorMessage}
                    setloader={setloader}
                    navigate={navigate}
                    email={email}
                    resetStep={resetStep}
                  />
                )}
              </div>
            </div>
          </div>
          <AuthenticateFooter />
        </div>
      </div>
    </>
  );
};

export default Signup;
